var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-title"},[(_vm.title)?_c('h1',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]):_c('h1',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t(_vm.$route.name))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }